import { currentAppEnvConfigs } from '@/configs/env'
import type { HomePageV2HeaderTab } from '@/services/cms/homePageV2'

// The CMS marks the Trending tab with this link value; it links out to the
// crypto.com marketing homepage instead of switching sections in place.
export const TRENDING_TAB_LINK = 'trending'

export interface ResolvedAssetNav {
  /** link value of the active tab (after fallback) */
  activeLink: string
}

/**
 * Resolve which tab is active from the asset_nav query param.
 * Falls back to the first non-trending tab when the param is missing,
 * equals 'trending', or matches nothing.
 */
export function resolveAssetNav(
  tabs: HomePageV2HeaderTab[] | undefined,
  assetNav: string | undefined,
): ResolvedAssetNav {
  const defaultLink = tabs?.find(tab => tab.link !== TRENDING_TAB_LINK)?.link
  const activeLink =
    assetNav && assetNav !== TRENDING_TAB_LINK && tabs?.some(tab => tab.link === assetNav)
      ? assetNav
      : defaultLink
  return { activeLink: activeLink ?? '' }
}

/**
 * Build the href for a header tab.
 * - trending → crypto.com marketing homepage for the locale
 * - every other tab → /[locale]/price?asset_nav={link}（默认 tab 也带参数，
 *   保证 DOM 层链接与激活状态一致）
 */
export function buildTabHref(tab: HomePageV2HeaderTab, locale: string): string {
  if (tab.link === TRENDING_TAB_LINK) {
    return `https://${currentAppEnvConfigs.marketingDomain}/${locale}`
  }
  return `/${locale}/price?asset_nav=${encodeURIComponent(tab.link)}`
}
